import React from 'react';
import styled from 'styled-components';
import HeroImage from '../../../images/public-home-hero-header.png';
// import DownloadStoreBadge from '../components/DownloadStoreBadge';
import {
  MD_MEDIA_BREAKPOINT,
  SM_MEDIA_BREAKPOINT,
  XL_MEDIA_BREAKPOINT,
} from '../../../constants';
import RoundButtonLink from '../../../components/ui/RoundButtonLink';
import RoundButton from '../../../components/ui/RoundButton';
import DownloadStoreBadge from '../components/DownloadStoreBadge';
import { isWebsiteShutdown } from '../../../env';
import { useWebsiteShutdownNotice } from '../../../components/website-shutdown/WebsiteShutdownNotice';

const StyleHeroSection = styled.div`
  padding: 200px 0 70px 0;
  background: url(${HeroImage}) top center;
  background-size: cover;
  background-repeat: no-repeat;
    left: 0;
    right: 0;
  .horror {
    color: #FF1800;
    font-family: SearsTower;
    font-size: 150px;
    font-weight: 400;
    text-transform: uppercase;
  }
  @media (max-width: ${XL_MEDIA_BREAKPOINT}){
    padding: 180px 0 70px 0;
  }
  @media (max-width: ${MD_MEDIA_BREAKPOINT}){
    padding: 160px 0 60px 0;

    .horror {
      font-size: 84px;
    }
  }
  @media (max-width: ${SM_MEDIA_BREAKPOINT}){

    h1 {
      font-size: var(--fs-2) !important;
    }
  }
`;
function HeroSection() {
  const { showNotice } = useWebsiteShutdownNotice();
  return (
    <StyleHeroSection className="hero-container px-3 d-flex justify-content-center align-items-center text-center flex-column bottom-0">
      <h1 className="m-0 fw-bold">THE SOCIAL NETWORK FOR</h1>
      <h2 className="horror m-0">Horror</h2>
      <div className="text-center d-xl-none">
        {isWebsiteShutdown
          ? <RoundButton variant="primary" className="text-uppercase px-4" onClick={showNotice}>Notice</RoundButton>
          : <RoundButtonLink variant="primary" className="text-uppercase" to="/app/sign-in">Sign in or create an account</RoundButtonLink>}
      </div>
      <div className="mt-4 mt-xl-0">
        <DownloadStoreBadge />
      </div>
    </StyleHeroSection>
  );
}

export default HeroSection;
